var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellow01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4b653;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.42,83.38c0-10.43-2.07-16.78-8.99-18.39,3.57-1.08,6.16-4.39,6.16-8.32,0-4.8-3.89-8.69-8.69-8.69s-8.69,3.89-8.69,8.69c0,3.92,2.6,7.23,6.16,8.32-2.84.66-4.86,2.12-6.26,4.34l-10.1,6.02c-.44.26-.78.62-1.01,1.04-.23-.42-.57-.78-1.01-1.04l-10.1-6.02c-1.4-2.21-3.42-3.68-6.26-4.34,3.57-1.08,6.16-4.39,6.16-8.32,0-4.8-3.89-8.69-8.69-8.69s-8.69,3.89-8.69,8.69c0,3.92,2.6,7.23,6.16,8.32-6.92,1.61-8.99,7.97-8.99,18.39h23.03c0-2.2-.09-4.22-.3-6.05l4.79,2.85c1.34.8,3.07.36,3.87-.98.01-.02.02-.04.03-.06.01.02.02.04.03.06.8,1.34,2.53,1.78,3.87.98l4.79-2.85c-.21,1.83-.3,3.85-.3,6.05h23.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.09,37.88c0,1.99-1.56,3.6-3.47,3.6h-10.21l-5.4,7.2-4.71-7.2h-10.91c-1.92,0-3.47-1.61-3.47-3.6v-17.66c0-1.99,1.55-3.6,3.47-3.6h31.23c1.92,0,3.47,1.61,3.47,3.6v17.66h0Zm-5.9-16.03h-26.19v2.35h26.19v-2.35h0Zm0,5.81h-26.19v2.35h26.19v-2.35h0Zm0,5.85h-26.19v2.35h26.19v-2.35h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow01);
export default __webpack_public_path__ + "static/media/yellow01.befedb306d36d5b9e09e74f87db90932.svg";
export { ForwardRef as ReactComponent };